import $ from "jquery";

import ActionDropdown from "./action_dropdown";

export default class ListActionDropdown extends ActionDropdown {
  initialize(options) {
    const defaultOptions = {
      title: '<i class="material-icons">more_horiz</i>',
      buttonType: 'xs',
      buttonClassName: 'btn-actions-menu',
      className: '', // allows for menu to render outside of a table (even one with overflow: auto)
      align: 'right',
      caret: false
    };

    const listOptions = $.extend({}, defaultOptions, options);

    super.initialize(listOptions);
  }
}
